// extracted by mini-css-extract-plugin
export default {"horizontalDivider":"style_horizontalDivider__8v6ta"};